export const audienceFrequenceFromService = (frequence) => ({
    demographics: frequence.demographics,
    interests: frequence.interests
});
export const audienceSegmentFromService = (segment) => ({
    id: segment.id,
    name: segment.name,
    insight: segment.insight,
    ...(segment.frequence && { frequence: audienceFrequenceFromService(segment.frequence) })
});
export const audienceSegmentsFromService = (segments) => ({
    insightBlurb: segments.insight_blurb,
    audiences: segments.audiences ? segments.audiences.map(audienceSegmentFromService) : null
});
//# sourceMappingURL=audience.js.map